import React from 'react';

import { BaseInputProps } from './index.types';
import { BaseInputView } from './index.view';

export function BaseInput(props: BaseInputProps) {
  return <BaseInputView {...props} />;
}

export default BaseInput;
export type { BaseInputProps, OptionItem } from './index.types';
